import { ActionIcon, Button, Group, Menu, useMantineTheme } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';

import styles from './SplitButton.module.scss';
import { Props } from './SplitButton.types';

const SplitButton = ({ label, onClick, leftSection, menuItems }: Props) => {
  const theme = useMantineTheme();

  return (
    <Group wrap="nowrap" gap={0}>
      <Button
        onClick={onClick}
        leftSection={leftSection}
        style={{
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        }}
      >
        {label}
      </Button>
      <Menu transitionProps={{ transition: 'pop' }} position="bottom-end" withinPortal>
        <Menu.Target>
          <ActionIcon
            variant="filled"
            color={theme.primaryColor}
            size={36}
            radius={0}
            className={styles.menuControl}
          >
            <IconChevronDown size={16} stroke={1.5} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          {menuItems.map((item, index) => (
            <Menu.Item key={index} leftSection={item.icon} onClick={item.onClick}>
              {item.label}
            </Menu.Item>
          ))}
        </Menu.Dropdown>
      </Menu>
    </Group>
  );
};

export default SplitButton;
